import React from "react";
import styled from "styled-components";
import Select from "components/common/Select";
import { defaultCompare } from "logic/DefaultCompare";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
const Container = styled.div`
  flex: 1;
  grid-area: streams;
`;
const StreamsFilter = ({ disabled = false, value = [], streams, onChange, multi = true, clearable = true }) => {
  const sendTelemetry = useSendTelemetry();
  const selectedStreams = value.join(",");
  const placeholder = "Select streams the search should include. Searches in all streams if empty.";
  const options = streams.sort(({ key: key1 }, { key: key2 }) => defaultCompare(key1, key2));
  const handleChange = (selected) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_STREAM_INPUT_CHANGED, {
      app_pathname: "search",
      app_section: "search-bar",
      app_action_value: "search-filter",
      event_details: {
        streamsCount: selected.split(",").length
      }
    });
    onChange(selected === "" ? [] : selected.split(","));
  };
  return /* @__PURE__ */ React.createElement(Container, { "data-testid": "streams-filter", title: placeholder }, /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder,
      disabled,
      clearable,
      "aria-label": placeholder,
      displayKey: "key",
      inputId: "streams-filter",
      onChange: handleChange,
      options,
      multi,
      value: selectedStreams
    }
  ));
};
export default StreamsFilter;
